// extracted by mini-css-extract-plugin
export default {"dashboardMenuList":"sideDrawerListItem_dashboardMenuList__lo5TA","active":"sideDrawerListItem_active__MLA4N","disabled":"sideDrawerListItem_disabled__y2dG7"};